<script setup>
import Category from '@/components/Category.vue'
import { strapiQuery } from '@/composables/strapiQuery'

const {
  data: categories,
  loading,
  error
} = strapiQuery('api/categories?populate=image&sort=name')
</script>

<template>
  <v-card class="mx-auto" max-width="600" border>
    <v-progress-linear v-if="loading" indeterminate color="primary" />
    <v-alert v-else-if="error" type="error" class="ma-4">
      Fehler beim Laden der Kategorien. Bitte überprüfen Sie die Verbindung zum CMS.
    </v-alert>
    <v-container v-else fluid>
      <Category
        v-for="category in categories"
        :id="category.id"
        :name="category.name"
        :headline="category.headline"
        :description="category.description"
        :img-url="category.image.formats.small.url"
        :key="category.id"
      />
    </v-container>
  </v-card>
</template>
